var App = App || {};

App.WidgetProducts = (function ($) {
    'use strict';

    function Init(widget) {
        Animate(widget);
        Tags(widget);
    }

    function Animate(widget) {
        const animate = widget.find(".widget-products__cards__layout");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".partial-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    function Tags(widget) {

        const tags = widget.find(".widget-products__tags > button[data-id]").toArray();
        const reset = widget.find(".widget-products__tags > button:not([data-id])");

        $(tags).on("click", function () {
            const isPressed = $(this).attr("aria-pressed") === "true";
            $(this).attr("aria-pressed", (!isPressed).toString());
            TagsResult(widget, tags);
        });

        reset.on("click", function () {
            $(tags).attr("aria-pressed", "false");
            TagsResult(widget, tags);
        });
    }

    function TagsResult(widget, tags) {

        const tagsActive = tags.filter(tag => tag.getAttribute("aria-pressed") === "true").map(tag => tag.getAttribute("data-id"));
        const cards = widget.find(".widget-products__cards__card").toArray();
        const noResults = widget.find(".widget-products__cards__noResults");

        if (tagsActive.length == 0) {
            $(cards).show();
            noResults.hide();
        }
        else {
            cards.forEach(card => {
                const tagsCard = card.getAttribute("data-tags").split(" ");
                const tagsMatch = tagsActive.every(tag => tagsCard.includes(tag));
                $(card).toggle(tagsMatch);
            });
            noResults.toggle($(cards).filter(":visible").length == 0);
        }

    }

    return {
        Init: Init
    };

})(jQuery);